import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { OWNERSHIP_CHANGE_PACKET } from "./apiRoutes";

interface mutateProps {
  ocpId: string;
  data: any;
}

const mutateSendOCPClosingEmail = async ({
  ocpId,
  data,
}: mutateProps) => {
  return await axiosAuth.post(
    `${OWNERSHIP_CHANGE_PACKET}/${ocpId}/closing-package/email/send`,
    data
  );
};

const useSendOCPClosingEmailMutation = (
  queryParams?: UseMutationOptions<
    any,
    Error,
    mutateProps,
    unknown
  >
) =>
  useMutation({
    mutationFn: mutateSendOCPClosingEmail,
    ...queryParams,
  });

export default useSendOCPClosingEmailMutation;
